<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj rolę' : 'Dodaj rolę' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa roli*" />
          </w-schema>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="saveRole">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';

import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/role.schema';

const emptyData = () => ({
  name: '',
  parent: {
    id: null
  }
});

// @vuese
// Modal do dodawania/edycji ról
// @group Roles
export default {
  components: { modal, WSchema },
  mixins: [manageMixin('roles', {}, emptyData)],
  props: {
    // Identyfikator roli nadrzędnej
    parentId: {
      type: Number,
      required: false,
      default: null
    }
  },
  schema,
  methods: {
    // @vuese
    // Zapisuje role
    saveRole() {
      this.model.parent.id = this.parentId;
      this.save();
    }
  }
};
</script>
